<template>
  <div class="default-list-wrap">
    <span :class="item.name==currentName?'list-item active':'list-item'" @click="chooseItem(item.name)" v-for="item in listData" :key="item.id">{{item.name}}</span>
  </div>
</template>

<script>
export default {
  name: 'defaultList',
  props: {
    listData: Array,
    currentValue: String
  },
  data () {
    return {
      currentName: '计量'
    }
  },
  mounted () {
    this.currentName = this.currentValue
    this.$store.commit('saveFilterList', this.listData)
  },
  methods: {
    chooseItem (name) {
      this.currentName = name
      localStorage.setItem('filterValue', name)
      this.$store.commit('saveFilterValue')
      // if (name === '标准') {
      //   this.$store.commit('saveMultipleValue', '国家标准')
      // }
      this.$emit('changeValue', this.currentName)
    }
  }
};
</script>

<style lang="less" scoped>
.default-list-wrap {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 8px 10px 0 rgba(0, 141, 255, 0.2);
  display: flex;
  flex-direction:column;
  justify-content: space-around;
  .list-item {
    font-size: 16px;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    line-height: 42px;
    padding: 0 24px;
    cursor: pointer;
  }
  .active{
       color: @color-blue
  }
  .list-item:hover{
   color: @color-blue
  }
}
</style>



// WEBPACK FOOTER //
// src/components/defaultList.vue